import NoticeLabel from "components/NoticeLabel";
import color from "constants/color";

export const NEWS_CATEGORY = {
  INCIDENT: "障害対応",
  MAINTENANCE: "メンテナンス情報",
  UPDATE: "アップデート情報",
} as const;

export type NewsCategory = (typeof NEWS_CATEGORY)[keyof typeof NEWS_CATEGORY];

const NewsNoticeLabel = ({ type }: { type: NewsCategory }) => {
  switch (type) {
    case NEWS_CATEGORY.INCIDENT:
      return (
        <NoticeLabel backgroundColor={color.warning} textColor={color.white}>
          {NEWS_CATEGORY.INCIDENT}
        </NoticeLabel>
      );
    case NEWS_CATEGORY.MAINTENANCE:
      return <NoticeLabel backgroundColor={color.attentionLight}>{NEWS_CATEGORY.MAINTENANCE}</NoticeLabel>;
    case NEWS_CATEGORY.UPDATE:
      return <NoticeLabel backgroundColor={color.lightCyan}>{NEWS_CATEGORY.UPDATE}</NoticeLabel>;
    default:
      return <NoticeLabel>{type}</NoticeLabel>;
  }
};

export default NewsNoticeLabel;
